var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPasswordsignin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.75 35.625V31.875H41.25V35.625H3.75ZM5.90625 24.2812L3.46875 22.875L5.0625 20.0625H1.875V17.25H5.0625L3.46875 14.5312L5.90625 13.125L7.5 15.8438L9.09375 13.125L11.5312 14.5312L9.9375 17.25H13.125V20.0625H9.9375L11.5312 22.875L9.09375 24.2812L7.5 21.4688L5.90625 24.2812ZM20.9062 24.2812L18.4688 22.875L20.0625 20.0625H16.875V17.25H20.0625L18.4688 14.5312L20.9062 13.125L22.5 15.8438L24.0938 13.125L26.5312 14.5312L24.9375 17.25H28.125V20.0625H24.9375L26.5312 22.875L24.0938 24.2812L22.5 21.4688L20.9062 24.2812ZM35.9062 24.2812L33.4688 22.875L35.0625 20.0625H31.875V17.25H35.0625L33.4688 14.5312L35.9062 13.125L37.5 15.8438L39.0938 13.125L41.5312 14.5312L39.9375 17.25H43.125V20.0625H39.9375L41.5312 22.875L39.0938 24.2812L37.5 21.4688L35.9062 24.2812Z",
    fill: "#780000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasswordsignin);
export default __webpack_public_path__ + "static/media/passwordsignin.30be8a98f7390a95a9bb5dcb44dc1e89.svg";
export { ForwardRef as ReactComponent };